/**
 * Country spelling alternatives configuration
 *
 * This utility handles alternative spellings for country names to improve
 * user experience when searching for countries in filters.
 *
 * Currently supports:
 * - "Türkiye" alternatives: "Turkye", "Turkiye"
 */

export const TURKIYE_ALTERNATIVES = [
  'turkye',
  'turkiye',
  'turkey',
  'Türkiye',
];

/**
 * Checks if a search term matches any of the alternative spellings for Türkiye
 * @param searchTerm - The user's search input (case-insensitive)
 * @returns boolean - True if the search term matches any alternative
 */
export const matchesTurkiyeAlternatives = (
  searchTerm: string
): boolean => {
  const normalizedSearch = searchTerm.toLowerCase();
  return TURKIYE_ALTERNATIVES.some(
    (alt) =>
      normalizedSearch.includes(alt) ||
      alt.includes(normalizedSearch)
  );
};

/**
 * Checks if a country name should be included when searching with alternative spellings
 * @param countryName - The country name to check
 * @param searchTerm - The user's search input
 * @returns boolean - True if the country should be included in results
 */
export const shouldIncludeCountryForAlternativeSpelling = (
  countryName: string,
  searchTerm: string
): boolean => {
  const normalizedCountry = countryName.toLowerCase();

  // Check if this is Türkiye and the search matches alternatives
  if (normalizedCountry.includes('türkiye')) {
    return matchesTurkiyeAlternatives(searchTerm);
  }

  return false;
};

/**
 * Example usage:
 *
 * User types "Turkye" → Should find "Türkiye"
 * User types "Turkiye" → Should find "Türkiye"
 * User types "Turkey" → Should find "Türkiye" (partial match)
 */
